module.exports = __webpack_public_path__ + "img/cprs-hs.af1d89a2.png";